import { Component, inject, input, Signal } from '@angular/core';
import { RebrandService } from 'src/app/core/services/rebrand.service';
import { iconMap } from '../../shared/enums/icon-map';
import { EIconPath } from '../../shared/enums/icons.enum';
import { IconModule } from '../icon/icon-module';

@Component({
  selector: 'pp-brand-logo',
  templateUrl: './brand-logo.component.html',
  styleUrls: ['./brand-logo.component.scss'],
  standalone: true,
  imports: [IconModule],
})
export class BrandLogoComponent {
  ppFallback = input<EIconPath>();

  EIconPath = EIconPath;
  iconMap = iconMap;

  readonly rebrandEnabled: Signal<boolean> = inject(RebrandService).rebrandEnabled;
}
